import { Injectable } from '@angular/core';

@Injectable()
export class SiteService {
    constructor() {}

    getSiteBaseUrl(): string {
        if (window.origin === undefined) {
            return (
                window.location.protocol +
                '//' +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port : '')
            );
        }

        return window.origin;
    }
}
